module.exports = __webpack_public_path__ + "img/SuperWA-Logo-1.cf473d57.svg";